import React from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardIcon, UserGroupFilledIcon } from 'assets';

import useAppSelector from 'hooks/redux/useAppSelector';

import userHasPermission from 'utils/auth/userHasPermission';

import { publicUrls } from 'constants/urls';

import { Roles } from 'types/auth';
import { ContactsFilled, SettingFilled } from '@ant-design/icons';

const useSidebarOptions = () => {
  const { t } = useTranslation();
  const { user } = useAppSelector(state => state.user);

  const isAnyAdmin = userHasPermission({ user, requiredAnyRoles: [Roles.ROOT_ADMIN, Roles.ADMIN] });

  const items = [];

  if (isAnyAdmin) {
    items.push(
      {
        key: publicUrls.main,
        link: publicUrls.main,
        label: t('header.dashboard'),
        icon: <DashboardIcon />,
      },
      {
        key: publicUrls.users.main,
        link: publicUrls.users.main,
        label: t('header.users'),
        icon: <UserGroupFilledIcon />,
      },
      {
        key: publicUrls.accounts.main,
        link: publicUrls.accounts.main,
        label: t('header.accounts'),
        icon: <ContactsFilled />,
      },
      {
        key: publicUrls.profile,
        link: publicUrls.profile,
        label: t('header.profile'),
        icon: <SettingFilled />,
      },
    );
  }

  return items;
};

export default useSidebarOptions;
